// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-danger[data-v-48904d20]{font-size:.53rem;font-weight:700;margin-bottom:.42rem}.desc[data-v-48904d20]{font-size:.34rem}.step-bar-bg[data-v-48904d20]{background:#f1f1f1;border-radius:.32rem;padding:.42rem;margin-bottom:.42rem}@media screen and (orientation:landscape){.btn-for-vertical[data-v-48904d20]{width:60%;margin:0 auto;padding-left:.6rem;padding-right:.6rem;box-sizing:border-box}.text-danger[data-v-48904d20]{text-align:center}}", ""]);
// Exports
module.exports = exports;
